import { Container, Box } from '@mui/material';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { LoginPage } from '../../features/pages/LoginPage';
import { FollowReportPage } from '../../features/pages/messaging/FollowReportPage';
import PageWithTokens from '../../features/pages/PageWithTokens';
import { Home } from '../../features/pages/home/Home';
import CreateReport from '../../features/pages/createReport/CreateReport';
import { useEffect } from 'react';
import { setStoredTokens } from '../../utils/setStoredTokens';


export const Main = () => {
  const location = useLocation()

  useEffect(() => {
    if (location.pathname !== '/follow-report') {
      setStoredTokens()
    }
  }, [location])

  return (
    <Container maxWidth="1440">
      <Box width={'95%'} m="auto" sx={{ pb: '10px', pt: '10xp' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/create-report" element={<CreateReport />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/report-credentials" element={<PageWithTokens />} />
          <Route path="/follow-report" element={<FollowReportPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Box>
    </Container>
  )
}
